calculatorJson = {
  "addon_type":"airf_g_1tile_upsel",
  "cpsl_amnt_1":"0.56 fl oz",
  "cpsl_amnt_2":"0.56 fl oz",
  "cpsl_amnt_3":"0.56 fl oz",
  "cpsl_cnt":"1",
  "cpsl_cont_1":"oil cleanser",
  "cpsl_cont_10":"cream conditioner",
  "cpsl_cont_11":"gel conditioner",
  "cpsl_cont_12":"cream face moisturizer",
  "cpsl_cont_13":"lotion face moisturizer",
  "cpsl_cont_14":"gel face moisturizer",
  "cpsl_cont_15":"balm face moisturizer",
  "cpsl_cont_16":"small pills",
  "cpsl_cont_17":"medium pills",
  "cpsl_cont_18":"large pills",
  "cpsl_cont_19":"small vitamins & supplements",
  "cpsl_cont_2":"gel cleanser",
  "cpsl_cont_20":"medium vitamins & supplements",
  "cpsl_cont_21":"large vitamins & supplements",
  "cpsl_cont_22":"thick sunscreen",
  "cpsl_cont_23":"thin sunscreen",
  "cpsl_cont_24":"body wash bar",
  "cpsl_cont_25":"cream body wash",
  "cpsl_cont_26":"gel body wash",
  "cpsl_cont_27":"oil body wash",
  "cpsl_cont_28":"cream body moisturizer",
  "cpsl_cont_29":"body oil",
  "cpsl_cont_3":"cream cleanser",
  "cpsl_cont_30":"thick face serum",
  "cpsl_cont_31":"thin face serum",
  "cpsl_cont_32":"liquid toner",
  "cpsl_cont_33":"liquid makeup remover",
  "cpsl_cont_34":"cream makeup remover",
  "cpsl_cont_35":"oil makeup remover",
  "cpsl_cont_36":"makeup remover balm",
  "cpsl_cont_37":"gel toothpaste",
  "cpsl_cont_38":"toothpaste tablets",
  "cpsl_cont_39":"rings",
  "cpsl_cont_4":"balm cleanser",
  "cpsl_cont_40":"necklaces",
  "cpsl_cont_41":"bracelets",
  "cpsl_cont_42":"earrings",
  "cpsl_cont_43":"hair gel",
  "cpsl_cont_44":"leave-in conditioner",
  "cpsl_cont_45":"hair serum",
  "cpsl_cont_46":"gel face exfoliator",
  "cpsl_cont_47":"scrub face exfoliator",
  "cpsl_cont_48":"chemical face exfoliator",
  "cpsl_cont_49":"hand cream",
  "cpsl_cont_5":"powder shampoo",
  "cpsl_cont_50":"lip balm",
  "cpsl_cont_51":"face oil",
  "cpsl_cont_52":"hair oil",
  "cpsl_cont_53":"shaving cream",
  "cpsl_cont_54":"shaving gel",
  "cpsl_cont_55":"shaving oil",
  "cpsl_cont_56":"powder face mask",
  "cpsl_cont_57":"clay face mask",
  "cpsl_cont_58":"cream face mask",
  "cpsl_cont_59":"gel face mask",
  "cpsl_cont_6":"shampoo bar",
  "cpsl_cont_60":"cream hair mask",
  "cpsl_cont_61":"cream aftershave",
  "cpsl_cont_62":"gel aftershave",
  "cpsl_cont_63":"oil aftershave",
  "cpsl_cont_64":"gel hand sanitizer",
  "cpsl_cont_65":"cream lube",
  "cpsl_cont_66":"gel lube",
  "cpsl_cont_67":"liquid mouthwash",
  "cpsl_cont_68":"mouthwash tablets",
  "cpsl_cont_69":"eye cream",
  "cpsl_cont_7":"gel shampoo",
  "cpsl_cont_70":"spot treatment",
  "cpsl_cont_8":"powder conditioner",
  "cpsl_cont_9":"conditioner bar",
  "cpsl_cpy_1":"The Capsule holds up to 10 uses of oil cleanser, making it perfect for week-long trips if used daily. If you cleanse twice a day, the Capsule holds enough for about half that time.",
  "cpsl_cpy_10":"The Capsule holds enough for up to 3 uses of cream conditioner, depending on hair length and density. If you condition your hair once or twice a week, the Capsule holds enough for a week-long trip.",
  "cpsl_cpy_11":"Tthe Capsule hold enough for up to 3 uses of gel conditioner, depending on hair length and density. If you condition your hair once or twice a week, the Capsule holds enough for a week-long trip.",
  "cpsl_cpy_12":"The Capsule holds enough cream face moisturizer for 13-14 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_13":"The Capsule holds enough lotion face moisturizer for 13-14 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_14":"The Capsule holds enough gel face moisturizer for 13-14 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_15":"The Capsule holds enough balm face moisturizer for 13-14 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_16":"The Capsule holds up to 25 small, round pills in the capsule (Think: Aspirin). If you take your medication daily, the Capsule can last you about a month's vacation.",
  "cpsl_cpy_17":"The Capsule holds about 8-9 medium capsule pills (or bullet-shaped pills). If you take your medication daily, the Capsule is great for a week-long trip.",
  "cpsl_cpy_18":"The Capsule holds about 4-5 large liquid gel pills,. If you take your medication daily, the Capsule would last for shorter trips (think less than a week).",
  "cpsl_cpy_19":"The Capsule holds up to thirty small, round pills in the capsule. If you take your supplements or vitamins daily, the Capsule can last you about a month's vacation.",
  "cpsl_cpy_2":"The Capsule holds up to 14 uses of gel cleanser, making it perfect for two-week trips if used daily. If you cleanse twice a day, the Capsule holds enough for about half that time.",
  "cpsl_cpy_20":"The Capsule holds about 8-9 medium capsule pills (or bullet-shaped pills). If you take your supplements or vitamins daily, the Capsule is great for a week-long trip.",
  "cpsl_cpy_21":"The Capsule holds about 4-5 large liquid gel pills. If you take your supplements or vitamins daily, your capsule will last for shorter trips (Think: less than a week).",
  "cpsl_cpy_22":"The Capsule holds enough thick sunscreen for 9-10 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_23":"The Capsule holds enough thin sunscreen for 12-13 uses, which will last one to two weeks depending on the number of times you apply per day.",
  "cpsl_cpy_24":"The Capsule holds enough of your body wash bar for 2-3 washes, or about as long as a weekend trip.",
  "cpsl_cpy_25":"The Capsule holds enough cream body wash for 2-3 washes, or about as long as a weekend trip.",
  "cpsl_cpy_26":"The Capsule holds enough gel body wash for 2-3 washes, or about as long as a weekend trip.",
  "cpsl_cpy_27":"The Capsule holds enough oil body wash for 2-3 washes, or about as long as a weekend trip.",
  "cpsl_cpy_28":"The Capsule holds about 1-2 uses of body moisturizer, enough to last for an overnight stay away from home.",
  "cpsl_cpy_29":"The Capsule holds about 1-2 uses of body oil, enough to last for an overnight stay away from home.",
  "cpsl_cpy_3":"The Capsule holds up to 14 uses of cream cleanser, making it perfect for two-week trips if used daily. If you cleanse twice a day, the Capsule holds enough for about half that time.",
  "cpsl_cpy_30":"The Capsule holds enough thick face serum for 3-4 uses which could last just under a week if used daily or longer if you alternate application days.",
  "cpsl_cpy_31":"The Capsule holds enough thin face serum for 5-6 uses which could last just under a week if used daily or longer if you alternate application days.",
  "cpsl_cpy_32":"The Capsule holds enough toner for 5-6 uses, which could last just under a week if used daily or longer if you alternate application days. We recommend placing your cotton pad over the Capsule, flipping, then applying to ensure no extra product is poured out. ",
  "cpsl_cpy_33":"The Capsule holds enough makeup remover for 4-5 uses, which could last just under a week if used daily or longer if you alternate application days. We recommend placing your cotton pad over the Capsule, flipping, then applying to ensure no extra product is poured out. ",
  "cpsl_cpy_34":"The Capsule holds enough cream makeup remover for 2-3 uses, which could last just under a week if used daily or longer if you alternate application days. ",
  "cpsl_cpy_35":"The Capsule holds enough oil makeup remover for 2-3 uses, which could last just under a week if used daily or longer if you alternate application days. ",
  "cpsl_cpy_36":"The Capsule holds enough cleansing balm for 7-10 uses, making it great for a week-long trip. If you cleanse multiple times a day or tend to need more product, your Capsule holds enough for 4-5 uses (think less than a week).",
  "cpsl_cpy_37":"The Capsule holds enough gel toothpaste for 2-3 uses, perfect for weekenders or overnight.",
  "cpsl_cpy_38":"The Capsule holds up to 20 toothpaste bits or tablets, which is enough for a two-week vacation.",
  "cpsl_cpy_39":"The Capsule holds around 4 thick rings comfortably (think: dome rings), or up to 8 thin rings (think: stackable rings), or your engagement ring and around 4 more stackable rings.",
  "cpsl_cpy_4":"The Capsule holds up to 14 uses of cream cleanser, making it perfect for two-week trips if used daily. If you cleanse twice a day, the Capsule holds enough for about half that time.",
  "cpsl_cpy_40":"The Capsules holds up to 4 necklaces that are thin (think chain necklaces) or up to 2 necklaces that are thicker, have pendants, pearls, or tags. Be sure to clasp them before placing them in your Capsule.",
  "cpsl_cpy_41":"The Capsule holds up to 2 thin, flexible bracelets.",
  "cpsl_cpy_42":"The Capsule holds up to two 2 small hoops, or up to 4 diamond studs and smaller earrings.",
  "cpsl_cpy_43":"If you have shorter or thinner hair or tend to only use hair gel sparingly, the Capsule holds enough for 1-3 uses. For longer or denser hair, the Capsule will be best overnight or for day outings.",
  "cpsl_cpy_44":"For longer or denser hair, the Capsule holds enough leave-in conditioner for 1-3 uses. For shorter or thinner hair, your Capsule holds enough for 4-6 uses, making it perfect for slightly longer trips (think more than a weekend, less than a week).",
  "cpsl_cpy_45":"The Capsule holds enough hair serum for 3-5 uses, depepending on hair length and density.",
  "cpsl_cpy_46":"The Capsule holds enough gel exfoliant for 13-14 uses, making it perfect for trips longer than a week if used daily. If you only exfoliate once or twice a week, your Capsule is perfect for a month-long trip.",
  "cpsl_cpy_47":"The Capsule holds enough physical exfoliant for 13-14 uses, making it perfect for trips longer than a week if used daily. If you only exfoliate once or twice a week, your Capsule is perfect for a month-long trip.",
  "cpsl_cpy_48":"The Capsule holds enough chemical exfoliant for 9-10 uses, making it perfect for a week-long trip if used daily. If you only exfoliate once or twice a week, your Capsule is perfect for much longer trips.",
  "cpsl_cpy_49":"The Capsule holds enough hand cream for 4-5 applications, or through a weekend trip. If you reapply throughout your day, it's perfect for a day out or overnight.",
  "cpsl_cpy_5":"The Capsule holds approximately 3 uses of powder shampoo depending on hair length and density. If you wash your hair once or twice a week, it will hold enough for a week long trip.",
  "cpsl_cpy_50":"The Capsule holds enough lip balm for up to 20 applications, which is perfect to last you a little over a week. If you reapply throughout your day, the Capsule holds enough for shorter trips (think less than a week). ",
  "cpsl_cpy_51":"The Capsule holds up to 8 uses of face oil, or enough for just over a week. If you apply twice per day, the Capsule will hold a long weekend's worth.",
  "cpsl_cpy_52":"The Capsule holds up to 6 uses of hair oil depending on hair length and density. If you apply hair oil once or twice a week, your Capsule will be perfect for a longer trip (think two weeks). ",
  "cpsl_cpy_53":"The Capsule holds up to 2 uses of shaving cream, which is just enough for overnight. If you only use it twice a week, your Capsule will hold enough for a week-long trip.",
  "cpsl_cpy_54":"The Capsule holds up to 2 uses of shaving gel, which is just enough for an overnight. If you only use it twice a week, your Capsule will hold enough for a week-long trip.",
  "cpsl_cpy_55":"The Capsule holds up to 2 uses of shaving oil, which is just enough for overnight. If you only use it twice a week, your Capsule will hold enough for a week-long trip.",
  "cpsl_cpy_56":"The Capsule holds enough powdered face mask for 1-2 uses, making it perfect for weekends or week-long trips, depending on how often you mask. Feel free to use your Capsule as a mixing container for ease.",
  "cpsl_cpy_57":"The Capsule holds enough clay face mask for 4-5 uses, making it perfect for weekends or week-long trips, depending on how often you mask.",
  "cpsl_cpy_58":"The Capsule holds enough cream face mask for 4-5 uses, making it perfect for weekends or week-long trips, depending on how often you mask. ",
  "cpsl_cpy_59":"The Capsule holds enough gel face mask for 4-5 uses, making it perfect for weekends or week-long trips, depending on how often you mask.",
  "cpsl_cpy_6":"The Capsule holds approximately 5 uses, depending on hair length and density. If you wash your hair once or twice a week, it holds enough for a week-long trip.",
  "cpsl_cpy_60":"The Capsule holds enough hair mask for 1-2 applications, depending on hair length and density. If you tend to do a hair mask once or twice a week, the Capsule is can last you multiple (or longer) trips.",
  "cpsl_cpy_61":"The Capsule holds enough cream aftershave for 3-4 uses, making it great for long weekenders or shorter trips (think less than a week) if used daily. If you shave once or twice a week, the Capsule can last you multiple trips.",
  "cpsl_cpy_62":"The Capsule holds enough gel aftershave for 7-8 uses, making it great for long weekenders or shorter trips (think less than a week) if used daily. If you shave once or twice a week, the Capsule can last you multiple trips.",
  "cpsl_cpy_63":"The Capsule holds enough oil aftershave for 3-4 uses, making it great for long weekenders or shorter trips (think less than a week) if used daily. If you shave once or twice a week, the Capsule is guaranteed to last you multiple trips.",
  "cpsl_cpy_64":"If you use an almond-sized amount, your Capsule holds enough 7-8 uses of hand sanitizer, which is enough to last you through a weekend trip. If you tend to use multiple times a day, the Capsule is perfect for a day of full activity.",
  "cpsl_cpy_65":"The Capsule holds 3-4 uses of cream lube, enough to last you through a weekend trip or overnight. ",
  "cpsl_cpy_66":"The Capsule holds 3-4 uses of gel lube, enough to last you through a weekend trip or overnight. ",
  "cpsl_cpy_67":"The Capsule holds enough liquid mouth wash for 2-3 uses – perfect for overnight adventures.",
  "cpsl_cpy_68":"The Capsule holds about 20 mouthwash tablets – perfect for long trips, and afterwards on your bathroom counter.",
  "cpsl_cpy_69":"The Capsule holds 7-14 uses of eye cream, which is enough enough to last through longer trips (Think: two weeks) if used daily. If you tend to use twice a day, the Capsule is perfect for a week-long trip.",
  "cpsl_cpy_7":"The Capsule holds enough for 3 uses of gel shampoo, depending on hair length and density. If you shampoo your hair once or twice a week, the Capsule holds enough for a week-long trip.",
  "cpsl_cpy_70":"If used sparingly or only a few times a week, the Capsule holds up to 30 uses of spot treatment, which is enough for longer trips (think: month-long trips). If you tend to use or reapply often, your Capsule will hold enough to last you up to two weeks.",
  "cpsl_cpy_8":"The Capsule holds enough for 3 uses of powder conditioner depending on hair length and density. If you condition your hair once or twice a week, the Capsule holds enough for a week-long trip.",
  "cpsl_cpy_9":"The Capsule holds enough for up to 5 uses from your conditioner bar, depending on hair length and density. If you condition your hair once or twice a week, the Capsule holds enough for a week-long trip.",
  "cpsl_days_1":"2-3 days",
  "cpsl_days_10":"&nbsp",
  "cpsl_days_11":"&nbsp",
  "cpsl_days_12":"&nbsp",
  "cpsl_days_13":"&nbsp",
  "cpsl_days_14":"&nbsp",
  "cpsl_days_15":"&nbsp",
  "cpsl_days_16":"&nbsp",
  "cpsl_days_17":"&nbsp",
  "cpsl_days_18":"&nbsp",
  "cpsl_days_19":"&nbsp",
  "cpsl_days_2":"5-7 days",
  "cpsl_days_20":"&nbsp",
  "cpsl_days_21":"&nbsp",
  "cpsl_days_22":"&nbsp",
  "cpsl_days_23":"&nbsp",
  "cpsl_days_24":"&nbsp",
  "cpsl_days_25":"&nbsp",
  "cpsl_days_26":"&nbsp",
  "cpsl_days_27":"&nbsp",
  "cpsl_days_28":"&nbsp",
  "cpsl_days_29":"&nbsp",
  "cpsl_days_3":"3-4 days",
  "cpsl_days_30":"&nbsp",
  "cpsl_days_31":"&nbsp",
  "cpsl_days_32":"&nbsp",
  "cpsl_days_33":"&nbsp",
  "cpsl_days_34":"&nbsp",
  "cpsl_days_35":"&nbsp",
  "cpsl_days_36":"&nbsp",
  "cpsl_days_37":"&nbsp",
  "cpsl_days_38":"&nbsp",
  "cpsl_days_39":"&nbsp",
  "cpsl_days_4":"&nbsp",
  "cpsl_days_40":"&nbsp",
  "cpsl_days_41":"&nbsp",
  "cpsl_days_42":"&nbsp",
  "cpsl_days_43":"&nbsp",
  "cpsl_days_44":"&nbsp",
  "cpsl_days_45":"&nbsp",
  "cpsl_days_46":"&nbsp",
  "cpsl_days_47":"&nbsp",
  "cpsl_days_48":"&nbsp",
  "cpsl_days_49":"&nbsp",
  "cpsl_days_5":"&nbsp",
  "cpsl_days_50":"&nbsp",
  "cpsl_days_51":"&nbsp",
  "cpsl_days_52":"&nbsp",
  "cpsl_days_53":"&nbsp",
  "cpsl_days_54":"&nbsp",
  "cpsl_days_55":"&nbsp",
  "cpsl_days_56":"&nbsp",
  "cpsl_days_57":"&nbsp",
  "cpsl_days_58":"&nbsp",
  "cpsl_days_59":"&nbsp",
  "cpsl_days_6":"&nbsp",
  "cpsl_days_60":"&nbsp",
  "cpsl_days_61":"&nbsp",
  "cpsl_days_62":"&nbsp",
  "cpsl_days_63":"&nbsp",
  "cpsl_days_64":"&nbsp",
  "cpsl_days_65":"&nbsp",
  "cpsl_days_66":"&nbsp",
  "cpsl_days_67":"&nbsp",
  "cpsl_days_68":"&nbsp",
  "cpsl_days_69":"&nbsp",
  "cpsl_days_7":"&nbsp",
  "cpsl_days_70":"&nbsp",
  "cpsl_days_8":"&nbsp",
  "cpsl_days_9":"&nbsp",
  "cpsl_img_1":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/small-cleanser-transparent-(1)16397565315593.png?v=1639756535",
  "cpsl_img_2":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/jelly-cleanser-small-transparent-(1)16397565772824.png?v=1639756580",
  "cpsl_img_3":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/small-cleanser-transparent-(2)16397566219755.png?v=1639756625",
  "cpsl_uses_1":"9-10 uses",
  "cpsl_uses_10":"2-3 uses",
  "cpsl_uses_11":"2-3 uses",
  "cpsl_uses_12":"13-14 uses",
  "cpsl_uses_13":"13-14 uses",
  "cpsl_uses_14":"12-13 uses",
  "cpsl_uses_15":"10-12 uses",
  "cpsl_uses_16":"25 uses",
  "cpsl_uses_17":"8-9 uses",
  "cpsl_uses_18":"4-5 uses",
  "cpsl_uses_19":"25-30 uses",
  "cpsl_uses_2":"13-14 uses",
  "cpsl_uses_20":"8-9 uses",
  "cpsl_uses_21":"4-5 uses",
  "cpsl_uses_22":"9-10 uses",
  "cpsl_uses_23":"12-13 uses",
  "cpsl_uses_24":"5-6 uses",
  "cpsl_uses_25":"2-3 uses",
  "cpsl_uses_26":"2-3 uses",
  "cpsl_uses_27":"2-3 uses",
  "cpsl_uses_28":"1-2 uses",
  "cpsl_uses_29":"1-2 uses",
  "cpsl_uses_3":"13-14 uses",
  "cpsl_uses_30":"5-6 uses",
  "cpsl_uses_31":"5-6 uses",
  "cpsl_uses_32":"6-7 uses",
  "cpsl_uses_33":"4-5 uses",
  "cpsl_uses_34":"2-3 uses",
  "cpsl_uses_35":"2-3 uses",
  "cpsl_uses_36":"7-10 uses",
  "cpsl_uses_37":"2-3 uses",
  "cpsl_uses_38":"20 uses",
  "cpsl_uses_39":"4-8 rings",
  "cpsl_uses_4":"13-14 uses",
  "cpsl_uses_40":"2-4 necklaces",
  "cpsl_uses_41":"2 bracelets",
  "cpsl_uses_42":"2-4 earrings",
  "cpsl_uses_43":"1-3 uses",
  "cpsl_uses_44":"3-6 uses",
  "cpsl_uses_45":"3-5 uses",
  "cpsl_uses_46":"13-14 uses",
  "cpsl_uses_47":"13-14 uses",
  "cpsl_uses_48":"9-10 uses",
  "cpsl_uses_49":"4-5 uses",
  "cpsl_uses_5":"2-3 uses",
  "cpsl_uses_50":"20 uses",
  "cpsl_uses_51":"7-8 uses",
  "cpsl_uses_52":"5-6 uses",
  "cpsl_uses_53":"1-2 uses",
  "cpsl_uses_54":"1-2 uses",
  "cpsl_uses_55":"1-2 uses",
  "cpsl_uses_56":"1-2 uses",
  "cpsl_uses_57":"4-5 uses",
  "cpsl_uses_58":"4-5 uses",
  "cpsl_uses_59":"4-5 uses",
  "cpsl_uses_6":"5-6 uses",
  "cpsl_uses_60":"1-2 uses",
  "cpsl_uses_61":"3-4 uses",
  "cpsl_uses_62":"7-8 uses",
  "cpsl_uses_63":"3-4",
  "cpsl_uses_64":"7-8 uses",
  "cpsl_uses_65":"3-4 uses",
  "cpsl_uses_66":"3-4 uses",
  "cpsl_uses_67":"2-3 uses",
  "cpsl_uses_68":"20 uses",
  "cpsl_uses_69":"7-14 uses",
  "cpsl_uses_7":"2-3 uses",
  "cpsl_uses_70":"14-30 uses",
  "cpsl_uses_8":"2-3 uses",
  "cpsl_uses_9":"5-6 uses",
  "cstm_prev":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/THE-CAPSULE-116606818376383.jpg?v=1660681841",
  "frm_bottom":"Free USA Shipping Over $65 & Free Returns",
  "nav_desc":"0.56 oz",
  "nav_prev":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/THE-CAPSULE-116606818619226.jpg?v=1660681872",
  "rcmd_item_1":"build-your-6###build-your-12###get-outside",
  "rcmnds":"build-your-6###build-your-12###get-outside",
  "recommend":{
    "rows":[
      [
        {
          "key":"rcmd_item_1",
          "label":"Product"
        }
      ]
    ]
  },
  "shop_desc":"Add-on to existing systems",
  "shop_prev":"https://cdn.shopify.com/s/files/1/0247/7326/3445/t/20/assets/THE-CAPSULE-116606818601275.jpg?v=1660681863",
  "shop_vid":"the-capsule.mp4",
  "shpfy_vid":"the-capsule.mp4"
}